import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { useAddPoderClienteMutation } from "src/services/clientesApi";
import saveFill from "@iconify/icons-eva/save-outline";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/HighlightOff";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  Grid,
  Alert,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LoadingButton } from "@material-ui/lab";

const styles = makeStyles(() => ({
  formControl: {
    minWidth: "100%",
    marginBottom: 7,
    marginTop: 12,
  },
  gridContainer: {},
  Container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 15,
  },
  textField: {
    width: "100%",
    marginBottom: 18,
    marginTop: 15,
  },
  textFieldComentario: {
    marginBottom: 18,
    marginTop: 20,
  },
  hidden: {
    display: "none",
  },
}));

export default function AdjuntarPoderCliente(props) {
  const { open, setOpen, setLoading, cliente, setShowAlert, setMessage } =
    props;
  const {
    sucursal: { refSucursal },
  } = useSelector((state) => state.auth.user);
  const classes = styles();
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addPoderCliente] = useAddPoderClienteMutation();

  const handleClose = () => {
    setOpen(false);
  };

  const guardarDatos = async () => {
    setIsSubmitting(true);
    if (file !== null) {
      await uploadFile("Tareas");
    } else {
      setIsSubmitting(false);
      setShowAlert(true);
      setMessage("Debe subir un archivo");
    }
  };

  const cerrar = () => {
    handleClose();
  };

  const handleFileInput = (e) => {
    const fileAux = e.target.files[0];
    if (fileAux === undefined) {
      return;
    }
    setFile(fileAux);
  };

  const handleDeleteFile = () => {
    setFile(null);
  };

  const actualizar = () => {
    setIsSubmitting(false);
    setOpen(false);
  };

  async function uploadFile() {
    setLoading(true);
    if (!file) return setLoading(false);
    const UPLOAD_FILE_SIZE_LIMIT = 150 * 1024 * 1024;

    if (file.size >= UPLOAD_FILE_SIZE_LIMIT) {
      setLoading(false);
      setShowAlert(true);
      setMessage("El archivo excede el tamaño máximo permitido.");
      return;
    }

    if (!refSucursal) {
      setLoading(false);
      setShowAlert(true);
      setMessage("Error: No se encontró una sucursal activa.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("refCliente", cliente.rut);
      formData.append("sucursal", refSucursal);

      await addPoderCliente(formData).unwrap();
      actualizar();
    } catch (ex) {
      console.error(ex);
      setShowAlert(true);
      setMessage("Error al subir el archivo.");
    } finally {
      setFile(null);
      setLoading(false);
    }
  }
  return (
    <>
      <div>
        <Dialog open={open} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Subir Archivo</DialogTitle>
          <DialogContent>
            <Card style={{ padding: "1rem" }}>
              <Alert severity="info">
                Haga click en el botón 'Seleccionar Archivo' para subir un
                documento.
              </Alert>

              <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={4} md={4}>
                  <input
                    className={classes.hidden}
                    id="contained-button-file"
                    onChange={handleFileInput}
                    type="file"
                  />

                  <label htmlFor={"contained-button-file"}>
                    <Button
                      fullWidth
                      component="span"
                      m={1}
                      variant="contained"
                    >
                      Seleccionar Archivo
                    </Button>
                  </label>
                </Grid>
                <Grid item xs={6} md={6}>
                  {file && (
                    <span>
                      <span>
                        <> {file.name}</>
                      </span>

                      <span>
                        <IconButton
                          onClick={handleDeleteFile}
                          aria-label="delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </span>
                    </span>
                  )}
                </Grid>
              </Grid>
            </Card>

            <DialogActions>
              <LoadingButton onClick={() => cerrar()} color="error">
                Cancelar
              </LoadingButton>
              <LoadingButton
                type="submit"
                color="primary"
                startIcon={<Icon icon={saveFill} />}
                loading={isSubmitting}
                onClick={guardarDatos}
              >
                Guardar Cambios
              </LoadingButton>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
